import React, { useState, useEffect } from 'react';
import Avatar1 from 'assets/jonahgeek.png';
import Avatar2 from 'assets/jonahgeek.png';
import Avatar3 from 'assets/jonahgeek.png';

const reviews = [
  {
    id: 1,
    name: 'Jonathan Mwebaze',
    role: 'Product Designer',
    feedback: 'Wire24 helped me send money to my family quickly and affordably. Best service ever!',
    avatar: Avatar1,
  },
  {
    id: 2,
    name: 'Mark K.',
    role: 'Engineer',
    feedback: 'The low fees and fast delivery make Wire24 my go-to remittance platform.',
    avatar: Avatar2,
  },
  {
    id: 3,
    name: 'Carlos D.',
    role: 'Director, Fenthr.',
    feedback:
      'Secure, reliable, and user-friendly. I trust Wire24 with all my international transfers.',
    avatar: Avatar3,
  },
];

export const TrustedByThousands = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full max-w-6xl my-12 md:my-48 mx-auto flex flex-col md:flex-row items-center justify-between py-12 px-6 md:px-16">
      {/* Header Section */}
      <div className="md:w-1/2 text-left">
        <h2 className="text-3xl md:text-7xl font-black">Trusted by Thousands</h2>
        <h2 className="text-3xl md:text-7xl font-black text-[#26C4FF]">Worldwide</h2>
      </div>

      {/* Reviews Carousel */}
      <div className="relative md:w-1/2 flex justify-center items-center h-96 md:h-64">
        {reviews.map((review, index) => {
          const position = (index - activeIndex + reviews.length) % reviews.length;
          const styles = [
            { transform: 'rotate(-9.52deg)', opacity: 1, zIndex: 3 },
            { transform: 'rotate(11.58deg)', opacity: 0.5, zIndex: 2 },
            { transform: 'rotate(31.3deg)', opacity: 0.1, zIndex: 1 },
          ];

          return (
            <div
              key={review.id}
              className="absolute w-[80vw] md:w-[30vw] p-6 bg-white shadow-lg rounded-lg transition-all duration-700"
              style={styles[position]}
            >
              <div className="flex items-center mb-4">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-12 h-12 rounded-full mr-4"
                />
                <div>
                  <h3 className="font-bold">{review.name}</h3>
                  <p className="text-gray-500 text-sm">{review.role}</p>
                </div>
              </div>
              <p className="text-gray-700 text-lg md:text-xl">{review.feedback}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
